import { db, FirebaseDocRefType } from 'firebase/index'
import { StoreGeoSearch } from 'types/storeGeoSearch'

export const fetchStoreGeoSearch = (storeRef: FirebaseDocRefType): Promise<StoreGeoSearch | undefined> => {
  return db
    .collection('stores_geo_search')
    .doc(storeRef.id)
    .get()
    .then((snapshot) => snapshot.data() as StoreGeoSearch)
    .catch((error) => {
      console.error(error)
      return undefined
    })
}
